"use client"

import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"


import { Checkbox } from "@/components/ui/checkbox"
import RolesRowActions from "./RolesRowActions"
import { format } from "date-fns"


export type Roles = {
    id: string
    name: number
    guard_name: string
    created_at: Date
    updated_at: Date
}
interface rowActionProps {
    onEdit: (data: any) => void
    onAddPermissions: (data: any) => void
    roles: string[]
}
export const rolesColumns = ({ onEdit, onAddPermissions, roles }: rowActionProps): ColumnDef<Roles>[] => {
    const columns: ColumnDef<Roles>[] = [
        {
            accessorKey: "id",
            header: "Id",
        },
        {
            accessorKey: "name",
            header: "Name",
        },
        {
            accessorKey: "created_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Created At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.created_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>
            },
        },
        {
            accessorKey: "updated_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Updated At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const formattedDate = format(new Date(row.original.updated_at), 'yyyy-MM-dd HH:mm:ss');
                return <span>{formattedDate}</span>
            },
        },
    ]
    if (roles.includes('role-edit') || roles.includes('role-delete') || roles.includes('permission-delete')) {
        columns.push({
            id: "actions",
            header: 'Actions',
            cell: ({ row }) => <RolesRowActions row={row} onEdit={onEdit} onAddPermissions={onAddPermissions} roles={roles} />,
        })
    }
    return columns
}
